import { useState } from "react";
import RoadMapNew from "../RoadMapNew";
import ProjectView from "../ProjectView";

// This component serves as a wrapper to switch between the RoadMap and Project views
const AppView = () => {
  const [currentView, setCurrentView] = useState<'roadmap' | 'projects'>('roadmap');
  
  const handleViewChange = (view: 'roadmap' | 'projects') => {
    setCurrentView(view);
  };
  
  return (
    <>
      {currentView === 'roadmap' ? (
        <RoadMapNew onViewChange={handleViewChange} />
      ) : (
        <ProjectView onViewChange={handleViewChange} />
      )}
    </>
  );
};

export default AppView; 